import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateThanksToYouQueries } from "Api/Mutations/Lead/invalidateThanksToYouQueries";
import { postLeadsThanksToYouWithdrawalRequestsTokenConfirmation } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

/**
 * Completes leaving Díky Tobě with the token from the e-mail link (ZS-1623). Anonymous on the API;
 * when the person happens to be signed in in this browser, their cached state is refetched.
 */
export const useConfirmThanksToYouWithdrawalMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((token: string) =>
      postLeadsThanksToYouWithdrawalRequestsTokenConfirmation(token),
    ),
    onSuccess: async () => {
      await invalidateThanksToYouQueries(queryClient);
    },
    onError: () => {}, // The page shows its own error state instead of the global error toast.
  });
};
